var $6f35d506eb75d574$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    //timeline
    let sections = gsap.utils.toArray(".panel");
    gsap.to(sections, {
        xPercent: 108 * (sections.length - 1),
        // xPercent: +100 * (sections.length - 1), //for arabic
        ease: "none",
        scrollTrigger: {
            trigger: "#timeline",
            start: "clamp(top top)",
            end: "clamp(bottom center)",
            pin: "#ipo-sub",
            //markers: true,
            id: "timeline",
            scrub: true
        }
    });
});


//# sourceMappingURL=ar.e5cf3f60.js.map
